/* eslint-disabled */

export default class PreferenceExtend {


  constructor (object?: any) {
  }

}
